import Button from '@rategravity/frontend/components/button';
import { event } from '@rategravity/frontend/modules/user-actions';
import { stringify } from 'querystring';
import React from 'react';
import { redactPiiFields } from '../../modules/pii-filter';
import './style.styl';

const TextRatesButton = ({
  textRatesExperiment,
  onClick = () => false,
  children,
  actionPipe,
  ...props
}) => {
  const baseUrl = `${process.env.MY_URL}/consult/text`;
  const { userId, ...queryTextRatesExperiment } = textRatesExperiment;
  const hashTextRatesExperiment = { userId };
  const to = `${baseUrl}?${stringify(queryTextRatesExperiment)}#${stringify(
    hashTextRatesExperiment
  )}`;
  const toPiiStripped = `${baseUrl}?${stringify(
    redactPiiFields(queryTextRatesExperiment)
  )}#${stringify(hashTextRatesExperiment)}`;
  return (
    <a href={to}>
      <Button
        onClick={(e) => {
          e.preventDefault();
          actionPipe.next(event('Clicked Text Rates Button', { consultUrl: toPiiStripped }));
          // wait 10ms for stuff to propogate
          window.setTimeout(() => {
            window.open(to, '_top');
          }, 10);
          return onClick(e);
        }}
        className="text-rates-btn"
        {...props}
      >
        {children}
      </Button>
    </a>
  );
};

export default TextRatesButton;



// WEBPACK FOOTER //
// ./src/components/text-rates-button/index.js